import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: {
    '&': tw`grid grid-cols-9 px-0 items-start`,
  },
  mobileGridLayout: {
    '@media (max-width: 768px)': {
      display: 'grid',
      gridTemplateColumns: '1fr',
    },
  },
}));
